// auto-generated by bin/genVersion.ts
export const VERSION = '2.1.0';
